import { createFileRoute } from "@tanstack/react-router";

import { StoryPage } from "@/features/content/pages";

export const Route = createFileRoute("/_app/growth/stories/$storyId")({
  component: OneStory,
});

function OneStory() {
  const { storyId } = Route.useParams();
  return <StoryPage key={storyId} storyId={storyId} />;
}
